<template>
<!-- Add Member Card -->
<v-btn v-if="add" flat small color="green" title="Invite Member" class="add">
  <v-icon>add</v-icon> Invite
</v-btn>

<!-- Member Display Card -->
<tr v-else>
  <td>
    <Avatar class="profile-image" :user="{photoURL: photoURL, displayName: displayName}" />&nbsp;&nbsp;{{ displayName }}</td>
</tr>
</template>

<script>
import Avatar from "@/components/User/Avatar";

export default {
  name: "MemberCard",
  components: {
    Avatar
  },
  props: {
    photoURL: String,
    displayName: String,
    add: {
      type: Boolean,
      default: false,
      required: false
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/User/MemberCard.vue